import Skeleton from "react-loading-skeleton";
import { useState } from "react";

export default function ImageSkeleton({ src, heightLoading = 200, className = "", alt = "image", ...res }) {
    const [loaded, setLoaded] = useState(false);

    if (!src) {
        return null;
    }

    return (
        <>
            {!loaded && <Skeleton containerClassName="w-100" height={heightLoading} className={className} />}
            <img 
                src={src} 
                alt={alt} 
                className={className} 
                onLoad={() => setLoaded(true)} 
                style={!loaded ? { display: 'none' } : {}} 
                {...res}
            />
        </>
    );
}
